import { Schema, DynamicColumn, DynamicField } from "lego-gui-lib";
import { AreaSplittingGroupFK } from "../schema";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { Auth } from "../../../../core/model/auth";
import { AreaSplittingFK } from "../../schema";
import { t } from "../../../../core/i18n/i18n";
import { mainStore, api } from "../../../../core/mainStore";
import { AreaFK, AreaSchema } from "../../../area/schema";
import {
  queryParamDtoStrategy
} from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";

export const GroupAreaSchema = new Schema<DynamicField>({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  fields: [
    {
      name: "areaSplittingRef",
      type: AreaSplittingFK,
      title: t("hns:areaSplitting:domain")
    },
    {
      name: "areaRef",
      type: AreaFK,
      title: t("hns:area:domain")
    },
    {
      name: "areaGroupRef",
      type: AreaSplittingGroupFK,
      title: t("hns:areaSplittingGroup:domain")
    }
  ]
});

export const GroupAreaColumns = new Schema({
  primaryKey: AreaSchema.primaryKey,
  security: GroupAreaSchema.security,
  fields: AreaSchema.fields
});

export const GroupAreaCreateSchema = GroupAreaSchema.extend<DynamicColumn>({
  areaSplittingRef: false,
  areaGroupRef: false
});

mainStore.areaSplittingGroupArea = RemoteChildDataSource.create({
  api: api,
  name: "areaSplittingGroupArea",
  schema: GroupAreaColumns,
  url: "/areas",
  commons: mainStore.commons,
  parent: mainStore.areaSplittingGroup.oneDataSource,
  dtoStrategy: queryParamDtoStrategy("id", "areaSplittingRef")
});
